import { Box, Button, Heading, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { IconLock } from 'assets/icons';
import { routePaths } from 'global/routePaths';

const ResetPasswordSuccess: React.FC<unknown> = () => {
  const { t } = useTranslation(['auth']);

  return (
    <Box minHeight="100vh" bg="white">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        minHeight="100vh"
        textAlign="center"
        p={{
          base: '32px 16px',
          md: '60px',
          lg: '33px',
          xl: '0 60px 60px',
          '2xl': '0 100px 100px',
        }}
      >
        <IconLock />
        <Heading as="h2" size="3xl" mb="2" mt="4">
          {t('auth:yourPassword')} <br /> {t('auth:hasBeenChanged')}
        </Heading>
        <Text fontSize="md" fontWeight="semibold" color="gray.500" mb="3">
          {t('auth:youCanNowLogInToTimeeroUsingTheNewPassword')}.
        </Text>
        <Button as={RouterLink} to={routePaths.auth.login}>
          {t('auth:logIn')}
        </Button>
      </Box>
    </Box>
  );
};

export default ResetPasswordSuccess;
